import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, skipWhile } from 'rxjs';

import { AbstractFetchAdaptor } from '../../../../common/fetch/abstract-fetch.adaptor';

interface ReferralFetchProps {
  token: string;
}
interface ReferralFetchResponse {
  referral: {
    survivor: {
      first_name: string;
      last_name: string;
      date_of_birth: string;
      email: string;
      phone: string;
    };
  };
}

@Injectable()
export class ReferralFetchAdaptor extends AbstractFetchAdaptor<ReferralFetchProps, ReferralFetchResponse> {
  name = 'referral-fetch';

  dataSubject = new BehaviorSubject<ReferralFetchResponse | null>(null);

  data$ = this.dataSubject.pipe(skipWhile((data) => data == null)) as Observable<ReferralFetchResponse>;

  private http = inject(HttpClient);

  override onRequest(props: ReferralFetchProps): Observable<ReferralFetchResponse> {
    return this.http.get<ReferralFetchResponse>(`/referrals/${props.token}.json`);
  }

  override onSuccess(_props: ReferralFetchProps, res: ReferralFetchResponse) {
    this.dataSubject.next(res);
  }
}
